import { LocalizedText } from '@mews/framework';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { ConnectedEditDialogForm } from '@mews-commander/legacy-form';
import { SmartDetailConfirmationForm } from '../StateTab';

const RESERVATION_CONFIRMATION_FORM_NAME = 'smart-detail-reservation-confirmation-form';

interface OwnProps {
    active: boolean;
    reservationIds: string[];
    closeDialog: () => void;
    onSuccess: () => void;
}

const ReservationConfirmationDialog = ({ onSuccess, active, reservationIds, closeDialog }: OwnProps) => (
    <ConnectedEditDialogForm
        formName={RESERVATION_CONFIRMATION_FORM_NAME}
        active={active}
        primaryButtonTextKey={TextKey.Confirm}
        primaryButtonDataTestId={DataTestId.ConfirmationButton}
        closeDialog={closeDialog}
        title={<LocalizedText textKey={TextKey.Confirm} />}
    >
        <SmartDetailConfirmationForm
            reservationIds={reservationIds}
            form={RESERVATION_CONFIRMATION_FORM_NAME}
            onSuccess={onSuccess}
        />
    </ConnectedEditDialogForm>
);

export default ReservationConfirmationDialog;
